/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bannerControllerCreate } from '../fn/banner/banner-controller-create';
import { BannerControllerCreate$Params } from '../fn/banner/banner-controller-create';
import { bannerControllerDelete } from '../fn/banner/banner-controller-delete';
import { BannerControllerDelete$Params } from '../fn/banner/banner-controller-delete';
import { bannerControllerFindAll } from '../fn/banner/banner-controller-find-all';
import { BannerControllerFindAll$Params } from '../fn/banner/banner-controller-find-all';
import { bannerControllerFindById } from '../fn/banner/banner-controller-find-by-id';
import { BannerControllerFindById$Params } from '../fn/banner/banner-controller-find-by-id';
import { bannerControllerReorder } from '../fn/banner/banner-controller-reorder';
import { BannerControllerReorder$Params } from '../fn/banner/banner-controller-reorder';
import { bannerControllerSearch } from '../fn/banner/banner-controller-search';
import { BannerControllerSearch$Params } from '../fn/banner/banner-controller-search';
import { bannerControllerToggleBlocked } from '../fn/banner/banner-controller-toggle-blocked';
import { BannerControllerToggleBlocked$Params } from '../fn/banner/banner-controller-toggle-blocked';
import { bannerControllerUpdate } from '../fn/banner/banner-controller-update';
import { BannerControllerUpdate$Params } from '../fn/banner/banner-controller-update';
import { BannerDto } from '../models/banner-dto';
import { BannerSearchResponseDto } from '../models/banner-search-response-dto';

@Injectable({ providedIn: 'root' })
export class BannerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bannerControllerFindAll()` */
  static readonly BannerControllerFindAllPath = '/api/banners';

  /**
   * 모든 Banner 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindAll$Response(params?: BannerControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BannerDto>>> {
    return bannerControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Banner 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindAll(params?: BannerControllerFindAll$Params, context?: HttpContext): Observable<Array<BannerDto>> {
    return this.bannerControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BannerDto>>): Array<BannerDto> => r.body)
    );
  }

  /** Path part for operation `bannerControllerCreate()` */
  static readonly BannerControllerCreatePath = '/api/banners';

  /**
   * 새 배너 등록.
   *
   * 새로운 배너를 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerCreate$Response(params: BannerControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    return bannerControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 배너 등록.
   *
   * 새로운 배너를 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerCreate(params: BannerControllerCreate$Params, context?: HttpContext): Observable<BannerDto> {
    return this.bannerControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerSearch()` */
  static readonly BannerControllerSearchPath = '/api/banners/search';

  /**
   * 배너 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerSearch$Response(params: BannerControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerSearchResponseDto>> {
    return bannerControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 배너 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerSearch(params: BannerControllerSearch$Params, context?: HttpContext): Observable<BannerSearchResponseDto> {
    return this.bannerControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<BannerSearchResponseDto>): BannerSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerFindById()` */
  static readonly BannerControllerFindByIdPath = '/api/banners/{id}';

  /**
   * 배너 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindById$Response(params: BannerControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    return bannerControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 배너 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindById(params: BannerControllerFindById$Params, context?: HttpContext): Observable<BannerDto> {
    return this.bannerControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerDelete()` */
  static readonly BannerControllerDeletePath = '/api/banners/{id}';

  /**
   * 배너 삭제.
   *
   * 배너를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerDelete$Response(params: BannerControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return bannerControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 배너 삭제.
   *
   * 배너를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerDelete(params: BannerControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.bannerControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `bannerControllerUpdate()` */
  static readonly BannerControllerUpdatePath = '/api/banners/{id}';

  /**
   * 배너 수정.
   *
   * 배너 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerUpdate$Response(params: BannerControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    return bannerControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 배너 수정.
   *
   * 배너 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerUpdate(params: BannerControllerUpdate$Params, context?: HttpContext): Observable<BannerDto> {
    return this.bannerControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerReorder()` */
  static readonly BannerControllerReorderPath = '/api/banners/reorder';

  /**
   * 배너 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerReorder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerReorder$Response(params: BannerControllerReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return bannerControllerReorder(this.http, this.rootUrl, params, context);
  }

  /**
   * 배너 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerReorder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerReorder(params: BannerControllerReorder$Params, context?: HttpContext): Observable<boolean> {
    return this.bannerControllerReorder$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `bannerControllerToggleBlocked()` */
  static readonly BannerControllerToggleBlockedPath = '/api/banners/{id}/toggle-blocked';

  /**
   * 배너 숨김/노출.
   *
   * 배너 게시글의 숨김/노출 상태를 컨트롤 합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerToggleBlocked()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerToggleBlocked$Response(params: BannerControllerToggleBlocked$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    return bannerControllerToggleBlocked(this.http, this.rootUrl, params, context);
  }

  /**
   * 배너 숨김/노출.
   *
   * 배너 게시글의 숨김/노출 상태를 컨트롤 합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerToggleBlocked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerToggleBlocked(params: BannerControllerToggleBlocked$Params, context?: HttpContext): Observable<BannerDto> {
    return this.bannerControllerToggleBlocked$Response(params, context).pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

}
